import styled, { css } from 'styled-components';

import font from '~/styled/font';
import textInputStd from '~/styled/text-input';

export const Label = styled.label`
  display: flex;
  align-items: center;
  width: ${({ contentWidth }) => contentWidth};
  height: 44px;
  padding: 0 8px;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  background-color: #FFFFFF;
  transition: all 150ms ease-out;
  
  &.input-focus {
    border-color: #222222;
  }
  
  ${({ isDisabled }) => isDisabled && css`
    border-color: #EDEDED;
    background-color: #FCFCFC;
    
    > input {
      background-color: #FCFCFC;
    }
    
    > svg {
      flex: none;
      
      path,
      circle,
      rect{
        fill: #CCCCCC !important;
      }
    }
    
    > p {
      color: #CCCCCC;
    }
  `}
`;

export const Input = styled.input`
  ${textInputStd};
  padding: 0 8px;

  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const SuffixText = styled.p`
  flex: none;
  padding-right: 8px;
  color: #222222;
  ${font.body3};
  font-weight: 400;
  word-break: keep-all;
`;

export const CloseBtn = styled.button`
  flex: none;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background-color: transparent;
`;
